import { IconButton, Tooltip, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import CenterFocusStrongIcon from '@material-ui/icons/CenterFocusStrong';
import CenterFocusWeakIcon from '@material-ui/icons/CenterFocusWeak';
import DeleteIcon from '@material-ui/icons/Delete';
import Star from '@material-ui/icons/Star';
import StarBorder from '@material-ui/icons/StarBorder';
import MolCard from 'components/MolCard';
import {
  getSelectedResultNum,
  removeResult,
  SearchResult,
  toggleFavourite,
} from 'features/searchMolecules/searchMoleculesSlice';
import { useThunkDispatch } from 'hooks';
import { DateTime } from 'luxon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cardActions: {
      padding: 0,
      justifyContent: 'center',
    },
  }),
);

interface Props {
  result: SearchResult;
  index: number;
  onSelection: (_: number) => void;
}

const ResultCard = ({ result, index, onSelection }: Readonly<Props>) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const selectedResultNum = useSelector(getSelectedResultNum);
  const dispatch = useThunkDispatch();

  return (
    <div>
      <MolCard
        depictNoStereo={true}
        smiles={result.refmol}
        raised={index === selectedResultNum}
        actionsProps={{ className: classes.cardActions }}
        actions={() => (
          <>
            <Tooltip arrow title={t('favourite')!}>
              <IconButton onClick={() => dispatch(toggleFavourite(index))}>
                {result.isFavourite ? <Star fontSize="small" /> : <StarBorder fontSize="small" />}
              </IconButton>
            </Tooltip>
            <Tooltip arrow title={t('selected_result')!}>
              <IconButton onClick={() => onSelection(index)}>
                {index === selectedResultNum ? (
                  <CenterFocusStrongIcon fontSize="small" />
                ) : (
                  <CenterFocusWeakIcon fontSize="small" />
                )}
              </IconButton>
            </Tooltip>
            <Tooltip arrow title={t('remove_result')!}>
              <IconButton onClick={() => dispatch(removeResult(index))}>
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </>
        )}
      >
        <div>
          <Typography display="block" variant="caption">
            {DateTime.fromMillis(result.timeOfResultAcquisition).toFormat('dd/LL HH:mm')}
          </Typography>
          <Typography display="block" variant="caption">
            {result.groupCount} {t('groups')}
          </Typography>
        </div>
      </MolCard>
    </div>
  );
};

export default ResultCard;
